import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
    Avatar,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Button,
    Link,
    Table,
    Grid,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    Select,
    MenuItem,
    TableRow,
    Typography,
    TextField
} from '@material-ui/core';

import { get_appointments, get_showrooms } from '../../../../api/API';
import TableEditBar from '../../../../components/TableEditBar/TableEditBar';
import moment from 'moment/moment.js'
import Showroom_Booking from '../Showroom_Booking/Showroom_Booking';
import Reallocate from '../Reallocate/Reallocate';
import CachedIcon from '@material-ui/icons/Cached';

const alternated_row_color = "rgb(221 152 21 / 8%)";
const useStyles = makeStyles(theme => ({
    root: {
        // padding: theme.spacing(3)
    },

    content: {
        padding: 0
    },

    inner: {
        minWidth: 700
    },

    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },

    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },

    actions: {
        // padding: theme.spacing(1),
        justifyContent: 'flex-end'
    }

}));
export default class TableList extends React.Component {

    constructor(props) {
        super(props);
        this.color_labeling = ['#cbfff740', 'rgba(139, 195, 74, 0.25)', '#dc747440'];
        this.day_labels = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        this.state = {

            showrooms: [],
            appointments: [],
            show_booking: false,
            reallocate_values: [],
            reallocate_max_appointment: 0,
            reallocate_timeslot_id: 0,
            highlight_slot: '',
            reallocate_timeslot: null,
            view_timeslot: null,
            open_reallocated: false,
            appointment_id: 0,
            values: {
                showroom: 0,
                date: moment(new Date()).format('YYYY-MM-DD')
            }
        }
    }

    handleChange(e) {
        this.setState({
            ...this.state,
            show_booking: false,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {
            this.get_timetable();
        });

    }

    async get_timetable() {
        let data = await get_appointments(this.state.values.showroom, this.state.values.date);
        if (data) {

            this.setState({
                ...this.state,
                appointments: this.format_data(data)
            });
        }
    }

    format_data(data) {

        for (let i = 0; i < data.length; i++) {

            if (data[i]['type'] == '1') {
                for (let j = 0; j < data[i].agencies.length; j++) {

                    var bookings = data[i].agencies[j]['bookings'];
                    for (let k = 0; k < parseInt(data[i].agencies[j].max_appointment); k++) {
                        if (k >= data[i].agencies[j]['bookings'].length) {
                            bookings[k] = {
                                empty: true
                            }
                        } else {
                            bookings[k] = data[i]['agencies'][j]['bookings'][k];
                        }
                    }
                    data[i]['agencies'][j]['bookings'] = bookings;
                }
            } else {
                var bookings = [];
                for (let k = 0; k < parseInt(data[i]['fcfs_appointment']); k++) {
                    var row = data[i]['bookings'].length > k ? data[i]['bookings'][k] : { empty: true };
                    bookings.push(row);
                }
                console.log('t ' + i, bookings);
                data[i]['bookings'] = bookings;
            }

        }
        console.log(data);
        return data;
    }
    handleCloseModal() {
        this.setState({
            ...this.state,
            open_reallocated: false
        });
    }
    async componentWillMount() {
        this.user_role = window.localStorage.getItem("role");
        let currentObj = this;
        let showrooms = await get_showrooms();
        if (showrooms) {
            currentObj.setState({
                ...this.state,
                showrooms: showrooms,
                values: {
                    ...currentObj.state.values,
                    showroom: showrooms ? showrooms[0]['property_id'] : 0
                }
            }, () => {
                currentObj.get_timetable();
                setInterval(() => {
                    if (currentObj.state.open_reallocated) return;
                    currentObj.get_timetable();
                }, 10000);
            });
        }

    }
    show_booking(id, timeslot) {
        console.log(timeslot);
        this.setState({
            ...this.state,
            show_booking: true,
            view_timeslot: timeslot,
            appointment_id: id
        });
    }

    closeinfo() { 
        this.get_timetable();
        this.setState({
            ...this.state,
            show_booking: false
        });
    }
    render() {
        return (
            <React.Fragment>

                <div
                    {...this.props}
                    className={clsx(this.props.classes.root, this.props.className)}
                >
                    <Typography
                        color="textSecondary"
                        gutterBottom
                        variant="body2"
                    >
                        {/* {appointments.length} Records found. Page {page + 1} of{' '}
                        {Math.ceil(appointments.length / rowsPerPage)} */}
                    </Typography>
                    {/* <Grid container spacing={1}>
                        <Grid item md={12}>
                            
                        </Grid>

                    </Grid> */}
                    <Card>
                        <CardHeader
                            //   action={<GenericMoreButton />}
                            title="Appointments"
                        />
                        <Divider />
                        <CardContent className={useStyles.content}>
                                <br></br>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "flex-end",
                                        justifyContent: "flex-end",
                                        width: "100%",
                                    }}
                                >
                                    <Select
                                        style={{
                                            width: "50%",
                                            marginRight: 20
                                        }}
                                        onChange={this.handleChange.bind(this)}
                                        name="showroom"
                                        value={this.state.values.showroom}
                                    >
                                        {
                                            this.state.showrooms.map((showroom) => (
                                                <MenuItem key={showroom.property_id}
                                                    value={showroom.property_id}>
                                                    {showroom.name}
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                    <TextField
                                        type="date"
                                        name="date"
                                        onChange={this.handleChange.bind(this)}
                                        value={this.state.values.date}
                                        style={{
                                            width: "30%"
                                        }}
                                    >

                                    </TextField>
                                </div>
                                {this.state.appointments && (
                                    <div >
                                        <br></br>
                                        {this.state.appointments[0] ?
                                            (
                                                this.state.appointments[0].is_special == "1" ?
                                                    <h3>{this.state.appointments[0].special_title}</h3>
                                                    :
                                                    <h3>{this.day_labels[this.state.appointments[0].day]}</h3>
                                            ) : ''
                                        }
                                        <br></br>
                                        <div style={{
                                            width: '100%',
                                            marginBottom: -10,
                                            display: 'flex',
                                            justifyContent: "flex-end"
                                        }}>
                                            <label
                                                style={{
                                                    marginRight: 20,
                                                }}
                                            >Legend :</label>

                                            <div style={{
                                                width: 20,
                                                height: 20,
                                                marginRight: 10,
                                                backgroundColor: "#cbfff740"
                                            }}></div>
                                            <label
                                                style={{
                                                    marginRight: 20,
                                                }}
                                            >booked</label>

                                            <div style={{
                                                width: 20,
                                                height: 20,
                                                marginRight: 10,
                                                backgroundColor: "rgba(139, 195, 74, 0.25)"
                                            }}></div>
                                            <label
                                                style={{
                                                    marginRight: 20,
                                                }}
                                            >arrived</label>
                                            <div style={{
                                                width: 20,
                                                height: 20,
                                                marginRight: 10,
                                                backgroundColor: "#dc747440"
                                            }}></div>
                                            <label style={{
                                                marginRight: 20,
                                            }}
                                            >no show</label>

                                        </div>
                                        <br /><br />
                                        <Table>

                                            <TableBody>
                                                {this.state.appointments.map(timeslot => (
                                                    <React.Fragment >
                                                        <TableRow

                                                            key={timeslot.timeslot_id}
                                                            style={{
                                                                color: "white",
                                                                backgroundColor: "black",
                                                                bordorBottomColor: "#dc9915",
                                                                borderBottomWidth: 2,
                                                                fontWeight: "bold"
                                                            }}
                                                        >
                                                            <TableCell style={{
                                                                color: "white"
                                                            }}>{timeslot.start_time} - {timeslot.end_time}</TableCell>
                                                            <TableCell
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "flex-end",
                                                                    alignItems: "flex-end",
                                                                    borderBottom: 0
                                                                }}
                                                            >
                                                                {timeslot.type == "1" && (this.user_role == 'admin' || this.user_role == 'superadmin' || this.user_role == "showroom_operator") ?
                                                                    <Button variant="contained" onClick={(() => {

                                                                        this.setState({
                                                                            ...this.state,
                                                                            reallocate_values: timeslot.agencies,
                                                                            open_reallocated: true,
                                                                            reallocate_max_appointment: timeslot.max_appointment,
                                                                            reallocate_timeslot: timeslot
                                                                        });
                                                                    }).bind(this)}>
                                                                        <CachedIcon></CachedIcon>
                                                                        Reallocate</Button> : ''}
                                                            </TableCell>
                                                        </TableRow>
                                                        {timeslot.type == '1' ?
                                                            <React.Fragment>
                                                                {timeslot.agencies.map((agency, agency_index) => (
                                                                    <React.Fragment>
                                                                        {
                                                                            agency.bookings.map((booking, index) => (
                                                                                <TableRow>
                                                                                    {index == 0 ?
                                                                                        <TableCell
                                                                                            style={{
                                                                                                backgroundColor: agency_index % 2 == 0 ? "#dd98154f" : '#f1c45cfa'
                                                                                            }}
                                                                                            rowSpan={agency.bookings.length}
                                                                                            >{agency.name}
                                                                                        </TableCell> : ''}
                                                                                    {
                                                                                        booking.empty ?
                                                                                            <TableCell

                                                                                                style={{
                                                                                                    paddingTop: 2,
                                                                                                    paddingBottom: 2,
                                                                                                    fontStyle: "italic",
                                                                                                    backgroundColor: agency_index % 2 == 0 ? "rgb(221 152 21 / 8%)" : '',
                                                                                                    outline: this.state.highlight_slot == "timeslot_" + timeslot.timeslot_id + "_agency_" + agency.agency_id + "_bookingi_" + index ? "2px solid #dc9a14" : '',
                                                                                                    outlineOffset: "-2px",
                                                                                                    //border: this.state.highlight_slot == "timeslot_" + timeslot.timeslot_id + "_agency_" + agency.agency_id + "_bookingi_" + index ? "2px solid #dc9a14" : ""
                                                                                                }}
                                                                                                onClick={(e) => {
                                                                                                    this.setState({
                                                                                                        ...this.state,
                                                                                                        highlight_slot: "timeslot_" + timeslot.timeslot_id + "_agency_" + agency.agency_id + "_bookingi_" + index
                                                                                                    }, () => {
                                                                                                        this.closeinfo();
                                                                                                    });
                                                                                                    console.log(this.state);

                                                                                                }}
                                                                                            >vacant</TableCell> :
                                                                                            <TableCell
                                                                                                onClick={((e) => {
                                                                                                    this.setState({
                                                                                                        ...this.state,
                                                                                                        highlight_slot: "timeslot_" + timeslot.timeslot_id + "_agency_" + agency.agency_id + "_bookingi_" + index
                                                                                                    }, () => {
                                                                                                        this.show_booking(booking.appointment_id, timeslot);
                                                                                                    });

                                                                                                }).bind(this)}
                                                                                                style={{
                                                                                                    backgroundColor: this.color_labeling[booking.status],
                                                                                                    outline: this.state.highlight_slot == "timeslot_" + timeslot.timeslot_id + "_agency_" + agency.agency_id + "_bookingi_" + index ? "2px solid #dc9a14" : '',
                                                                                                    outlineOffset: "-2px",
                                                                                                    //border: this.state.highlight_slot == "timeslot_" + timeslot.timeslot_id + "_agency_" + agency.agency_id + "_bookingi_" + index ? "2px solid #dc9a14" : ""
                                                                                                }}
                                                                                            ><strong>Number Of Guests :</strong> {agency.username} <strong>Pax : </strong> {booking.pax} <strong>Number Of Agents : </strong> {booking.agent_pax}</TableCell>
                                                                                    }

                                                                                </TableRow>
                                                                            ))
                                                                        }
                                                                    </React.Fragment>

                                                                ))}
                                                            </React.Fragment>
                                                            :
                                                            <React.Fragment>
                                                                <React.Fragment>
                                                                    <TableRow>
                                                                        <TableCell
                                                                            style={{
                                                                                backgroundColor: "#dd98154f"
                                                                            }}
                                                                            rowSpan={parseInt(timeslot.fcfs_appointment) + 1}>
                                                                            <span style={{
                                                                                fontWeight: "bold",
                                                                                textDecoration: "underline"
                                                                            }}>
                                                                                FCFS {timeslot.fcfs_appointment} slots
                                                                            </span>
                                                                            {timeslot.agencies.map((agency) => (
                                                                                <div>
                                                                                    {agency.name}
                                                                                </div>
                                                                            ))}

                                                                        </TableCell>
                                                                    </TableRow>
                                                                    {
                                                                        timeslot.bookings.map((booking, index) => (
                                                                            booking.empty ?

                                                                                <TableRow>
                                                                                    <TableCell

                                                                                        style={{
                                                                                            paddingTop: 2,
                                                                                            paddingBottom: 2,
                                                                                            fontStyle: "italic",
                                                                                            outline: this.state.highlight_slot == "timeslot_" + timeslot.timeslot_id + "_fcfs_" + index ? "2px solid #dc9a14" : '',
                                                                                            outlineOffset: "-2px",
                                                                                            //border: this.state.highlight_slot == "timeslot_" + timeslot.timeslot_id + "_fcfs_" + index ? "2px solid #dc9a14" : ""
                                                                                        }}

                                                                                        onClick={(e) => {
                                                                                            this.setState({
                                                                                                ...this.state,
                                                                                                highlight_slot: "timeslot_" + timeslot.timeslot_id + "_fcfs_" + index
                                                                                            }, () => {
                                                                                                this.closeinfo();
                                                                                            });
                                                                                        }}
                                                                                    >vacant</TableCell>

                                                                                </TableRow> :

                                                                                <TableRow>
                                                                                    <TableCell
                                                                                        onClick={((e) => {
                                                                                            this.setState({
                                                                                                ...this.state,
                                                                                                highlight_slot: "timeslot_" + timeslot.timeslot_id + "_fcfs_" + index
                                                                                            }, () => {
                                                                                                this.show_booking(booking.appointment_id, timeslot);
                                                                                            });
                                                                                            // this.show_booking(booking.appointment_id, timeslot);
                                                                                        }).bind(this)}
                                                                                        style={{
                                                                                            backgroundColor: this.color_labeling[booking.status],
                                                                                            outline: this.state.highlight_slot == "timeslot_" + timeslot.timeslot_id + "_fcfs_" + index ? "2px solid #dc9a14" : '',
                                                                                            outlineOffset: "-2px",
                                                                                            //border: this.state.highlight_slot == "timeslot_" + timeslot.timeslot_id + "_fcfs_" + index ? "2px solid #dc9a14" : ""
                                                                                        }}
                                                                                    ><span style={{
                                                                                        fontWeight: 'bold'
                                                                                    }}>{booking.name}</span>  Pax : {booking.pax}</TableCell>
                                                                                </TableRow>
                                                                        ))

                                                                    }

                                                                </React.Fragment>
                                                            </React.Fragment>


                                                        }
                                                    </React.Fragment>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                )}

                        </CardContent>

                    </Card>

                </div >
                {
                    this.state.show_booking && (
                        <Showroom_Booking

                            open={this.state.show_booking}
                            closeaction={this.closeinfo.bind(this)}
                            date={this.state.values.date}
                            timeslot={this.state.view_timeslot}
                            appointment_id={this.state.appointment_id}
                            classes={this.props.classes}></Showroom_Booking>
                    )}
                {this.state.open_reallocated && (
                    <Reallocate

                        timeslot_id={this.state.reallocate_timeslot.timeslot_id}
                        date={this.state.values.date}
                        onClose={this.handleCloseModal.bind(this)}
                        agencies={this.state.reallocate_values}
                        open={this.state.open_reallocated}
                        max_appointment={this.state.reallocate_max_appointment}
                    ></Reallocate>
                )}

            </React.Fragment>
        );

    }


}